import arenaScene from '../assets/scenes/arena.svg';
import moltenScene from '../assets/scenes/molten.svg';
import frozenScene from '../assets/scenes/frozen.svg';
import swampScene from '../assets/scenes/swamp.svg';
import stormScene from '../assets/scenes/storm.svg';

import drakeSprite from '../assets/monsters/drake.svg';
import lichSprite from '../assets/monsters/lich.svg';
import golemSprite from '../assets/monsters/golem.svg';
import wardenSprite from '../assets/monsters/warden.svg';
import serpentSprite from '../assets/monsters/serpent.svg';

// The roster — cycled & mixed with backdrops for endless, varied fights.
export const MONSTERS = [
  { id: 'drake', name: 'EMBERMAW', subtitle: 'The Ashen Drake', maxHp: 90, intent: 'SCORCH', sprite: drakeSprite },
  { id: 'lich', name: 'THE GILDED LICH', subtitle: 'Keeper of Hollow Crowns', maxHp: 80, intent: 'HEX', sprite: lichSprite },
  { id: 'golem', name: 'GRULDIN', subtitle: 'Stone Tyrant', maxHp: 110, intent: 'CRUSH', sprite: golemSprite },
  { id: 'warden', name: 'THE HOLLOW WARDEN', subtitle: 'Eternal Sentinel', maxHp: 100, intent: 'GUARD', sprite: wardenSprite },
  { id: 'serpent', name: 'VEXIL', subtitle: 'The Void Serpent', maxHp: 85, intent: 'DEVOUR', sprite: serpentSprite },
];

export const BACKDROPS = [arenaScene, moltenScene, frozenScene, swampScene, stormScene];
